import React from 'react';
import styles from './Press.module.scss';
import { aspectRatio, data } from './pressPageData';
import Image from '@/src/shared/components/Image';
import { CarouselV2, Slide } from '@/src/shared/components/Carousel/CarouselV2';
import { Section } from '@/src/containers/Landings/Section';

const Press = () => {
  const openLink = (l) => {
    window.open(l, '_blank');
  };

  return (
    <Section className={styles.container}>
      <p className={styles.headerTitle}>From The Press</p>
      <CarouselV2
        classes={{ container: styles.carouselContainer }}
        dragFree={false}
        align="center"
      >
        {data.slice(0, 4).map((item) => (
          <Slide className={styles.card} key={item.title}>
            <div key={item.articleURL} className={styles.cardContainer}>
              <div className={styles.logoWrapper}>
                <Image
                  width={aspectRatio[item.pressLogoURL] * 28}
                  height={28}
                  alt={item.pressName}
                  className={styles.innerImage}
                  objectFit="contain"
                  src={`/images/press/logos/${item.pressLogoURL}`}
                />
              </div>
              <div className={styles.image}>
                <Image
                  onClick={() => openLink(item.articleURL)}
                  alt={item.articleName}
                  fill
                  className={styles.innerImage}
                  objectFit="cover"
                  src={`/images/press/thumbnails/${item.articleImgURL}`}
                />
              </div>

              <a
                rel="noreferrer"
                target="_blank"
                className={styles.articleTitle}
                href={item.articleURL}
              >
                <h3 className={styles.articleTitle}>{item.articleName}</h3>
              </a>
              <div className={styles.date}>{item.date}</div>
              <a
                target="_blank"
                rel="noreferrer"
                className={styles.readMore}
                href={item.articleURL}
              >
                Read More{' '}
                <Image
                  width={15}
                  height={15}
                  alt={item.pressName}
                  className={styles.innerImage}
                  src="/images/about-us/share.svg"
                />
              </a>
            </div>
          </Slide>
        ))}
      </CarouselV2>
    </Section>
  );
};
export default Press;
